'use client'

import * as React from 'react'
import { I18nextProvider } from 'react-i18next'
import { createStudioShellI18n } from '../lib/studio-shell-i18n'

export function StudioReactI18nProvider({
  shellTranslations,
  children,
}: {
  shellTranslations: Record<string, string>
  children: React.ReactNode
}) {
  const instance = React.useMemo(
    () => createStudioShellI18n(shellTranslations),
    [shellTranslations],
  )

  return <I18nextProvider i18n={instance}>{children}</I18nextProvider>
}
